import React from 'react';
import { TrackedObjects, TrackedObjectsProps } from '@tier4/autowareviz-react-threejs';
import { DirectionalObstacleRenderer } from '../DirectionalObstacleRenderer';
import { ShapeBuilder, ShapeCache, TrackingObjectRenderer } from '@tier4/autowareviz-threejs';
import { useCallback } from 'react';
import { useDisposable } from '@tier4/autowareviz-react';

export type DirectionalTrackedObjectsProps<T extends {}> = TrackedObjectsProps<T>;

export function DirectionalTrackedObjects<T extends {}>(props: DirectionalTrackedObjectsProps<T>) {
    const createBuilder = useCallback(() => new ShapeBuilder(), []);
    const builder = useDisposable(createBuilder);
    const createCache = useCallback(
        () => (builder ? new ShapeCache(builder) : undefined),
        [builder]
    );
    const cache = useDisposable(createCache);
    const createRenderer = useCallback(
        () => (cache ? new DirectionalObstacleRenderer(new TrackingObjectRenderer<T>(cache)) : undefined),
        [cache]
    );

    return (
        <TrackedObjects
            {...props}
            createObjectRenderer={createRenderer}
        />
    );
}
